var map = {
	"./vip.png": "17c8",
	"./vip0.png": "ac607",
	"./vip1.png": "b4c1",
	"./vip2.png": "9dba",
	"./vip3.png": "3375",
	"./vip4.png": "0ba5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f294";